function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Base from "../Base/Base";
import "./ContextTip.css";
export default /*#__PURE__*/React.forwardRef(ContextTip);

function ContextTip({
  color,
  direction,
  children,
  ...rest
}, ref) {
  const classes = classnames(`ax-context-tip--${direction}`, {
    [`ax-context-tip--${color}`]: color
  });
  return /*#__PURE__*/React.createElement(Base, _extends({
    className: classes
  }, rest), /*#__PURE__*/React.createElement("span", {
    className: "ax-context-tip__arrow",
    ref: ref
  }), /*#__PURE__*/React.createElement(Base, {
    className: "ax-context-tip__content"
  }, children));
}